export const Panel = {
  Primary: 0,
  Secondary: 1,
};

export const PanelDisplayState = {
  OneThird: 0,
  TwoThird: 1,
  Full: 2,
  None: 3,
};

export const PanelPresets = {
  OneThirdTwoThird: {
    panelOneDisplay: PanelDisplayState.OneThird,
    panelTwoDisplay: PanelDisplayState.TwoThird,
  },

  TwoThirdOneThird: {
    panelOneDisplay: PanelDisplayState.TwoThird,
    panelTwoDisplay: PanelDisplayState.OneThird,
  },
  OneFull: {
    panelOneDisplay: PanelDisplayState.Full,
    panelTwoDisplay: PanelDisplayState.None,
  },
  TwoFull: {
    panelOneDisplay: PanelDisplayState.None,
    panelTwoDisplay: PanelDisplayState.Full,
  },
};

export const SearchType = {
  Patient: 0,
  Caregiver: 1,
  Transporter: 2,
  DocTypeState: 4
};

export const OrderStatus = {
  Open: 1,
  Completed: 2,
  Cancelled: 3,
  Expired: 4,
  Scheduled: 5,
};

export const OrderType = {
  'Low-THC Cannabis': 1,
  'Medical Marijuana': 2,
  'Smoking Marijuana': 3,
};

export const DeliveryStatus = {
  NotDelivered: 1,
  Delivered: 2,
  Failed: 3,
  Undeliverable: 4,
  GivenToPatient: 5,
  ToBeAssigned: 6
};

export const MmtcStatus = {
  Open: 1,
  'Shut Down': 2
};

export const MenuType = {
  MainMenu: 1,
  UserMenu: 2,
  MobileMenu: 3,
};

export const MenuItemType = {
  Navigation: 1,
  Text: 2,
  Divider: 3,
};

export const USER_STATUS_DROPDOWN = [
  { name: 'All', id: '' },
  { name: 'Active', id: '1' },
  { name: 'Inactive', id: '2' },
  { name: 'Locked', id: '3' },
  { name: 'New', id: '4' },
  { name: 'Pending Executive Approval', id: '6' },
  { name: 'Pending OMMU Approval', id: '7' },
  { name: 'Pending Training', id: '5' }
];

export const DELETED_STATUS_DROPDOWN = [
  { name: 'All', id: '' },
  { name: 'Deleted', id: 'true' },
  { name: 'Not Deleted', id: 'false' },
];

export const UserStatus = {
  Active: 1,
  Inactive: 2,
  Locked: 3,
  New: 4,
  PendingTraining: 5,
  PendingExecutiveApproval: 6,
  PendingOMMUApproval: 7,
  Deleted: 8
};

export const AdminUserRole = {
  SystemAdmin: 1,
  CatalisAdmin: 18,
  CatalisCallCenter: 19,
  CatalisDocManagement: 20,
  LimitedAdmin: 22,
  SupportAdmin: 23
};

export const PhysicianUserRole = {
  Physician: 2,
  ReviewingPhysician: 21
};

export const CardholderUserRole = {
  Patient: 14,
  LegalRepresentative: 15
};

export const LeoUserRole = {
  LawEnforcement: 4,
  LawEnforcementManager: 8,
  ExecutiveLawEnforcementManager: 11,
};

export const MmtcUserRole = {
  Mmtc: 3,
  MmtcManager: 7,
  Deliverer: 9,
  ExecutiveMmtcManager: 10,
};

export const UserRole = {
  SystemAdmin: 1,
  Physician: 2,
  Mmtc: 3,
  LawEnforcement: 4,
  OCUStaff: 5,
  Researcher: 6,
  MmtcManager: 7,
  LawEnforcementManager: 8,
  Deliverer: 9,
  ExecutiveMmtcManager: 10,
  ExecutiveLawEnforcementManager: 11,
  Audit: 12,
  MedicalDirector: 13,
  Patient: 14,
  Caregiver: 15,
  DOHStaff: 16,
  CardProgramStaff: 17,
  CatalisAdmin: 18,
  CatalisCallCenter: 19,
  CatalisDocManagement: 20,
  ReviewingPhysician: 21,
  LimitedAdmin: 22,
  SupportAdmin: 23,
  OMMUDocStaff: 25,
  OMMUCallStaff: 26
};

export const UserType = {
  Admin: 1,
  Physician: 2,
  CardHolder: 3,
  Leo: 4,
  Mmtc: 5
};

export const UserSigned = {
  Signed: 'Y',
  NotSigned: 'N'
};

export const UserTrained = {
  Trained: 'Y',
  NotTrained: 'N',
  RenewalDue: 'R'
};

export const Onboarded = {
  Onboarded: 'Yes',
  NotOnboarded: 'No',
  NotApplicable: 'N/A'
};

export const TransporterStatus = {
  NotApplicable: 'Onboarded: N/A',
  Onboarded: 'Onboarded: Yes',
  NotOnboarded: 'Onboarded: No',
  Removed: 'Removed'
};

export const OrderRoutes = {
  Oral: 1,
  Topical: 2,
  Sublingual: 3,
  Inhalation: 4,
  Suppository: 5,
  Smoking: 6,
  Edibles: 7
};

export const calculationRouteTabs = [
  { id: 0, name: 'Aggregate' },
  { id: 1, name: 'Oral' },
  { id: 2, name: 'Topical' },
  { id: 3, name: 'Sublingual' },
  { id: 4, name: 'Inhalation' },
  { id: 5, name: 'Edibles' },
  { id: 6, name: 'Suppository' }
];

export const OrderRoutesArray = [
  { id: 1, name: 'Oral' },
  { id: 2, name: 'Topical' },
  { id: 3, name: 'Sublingual' },
  { id: 4, name: 'Inhalation' },
  { id: 5, name: 'Suppository' },
  { id: 6, name: 'Smoking' },
  { id: 7, name: 'Edibles' }
];

export const patientApplicationStatus = {
  NotInitiated: 1, // Indicates an application has not been started for this card-holder.
  Pending: 2, // An application that has been submitted for review but is not yet approved.
  Active: 3, // Card-holder currently has an active and approved application.
  Deceased: 4, // Card-holder is currently identified as deceased.
  Expired: 5, // Card-holder's most recent approved application has expired.
  CardStatusInvalid: 6, // Card-holder's card status is not valid.
};

export const cardStatus = {
  None: 1,
  Revoked: 2,
  Suspended: 3,
  Surrendered: 4,
  Deceased: 5,
  Reinstated: 6 // not an existing state, only use to identify when a Reinstate happens
};

export const CARD_STATUS_DROPDOWN = [
  { name: 'All', id: '' },
  { name: 'None', id: 1 },
  { name: 'Revoked', id: 2 },
  { name: 'Surrendered', id: 4 },
  { name: 'Suspended', id: 3 },
  { name: 'Deceased', id: 5 },
  { name: 'Reinstated', id: 6 }
];

export const USER_ROLE_DROPDOWN = [
  { name: 'All', id: '' },
  { name: 'System Admin', id: 1 },
  { name: 'Physician', id: 2 },
  { name: 'MMTC', id: 3 },
  { name: 'Law Enforcement', id: 4 },
  { name: 'OCU Staff', id: 5 },
  { name: 'Researcher', id: 6 },
  { name: 'MMTC Manager', id: 7 },
  { name: 'Law Enforcement Manager', id: 8 },
  { name: 'Deliverer', id: 9 },
  { name: 'Executive MMTC Manager', id: 10 },
  { name: 'Executive LEO Manager', id: 11 },
  { name: 'Audit', id: 12 },
  { name: 'Medical Director', id: 13 },
  { name: 'Patient', id: 14 },
  { name: 'Legal Representative', id: 15 },
  { name: 'DOH Staff', id: 16 },
  { name: 'Card Program Staff', id: 17 },
  { name: 'Catalis Admin', id: 18 },
  { name: 'Catalis Call Center', id: 19 },
  { name: 'Catalis Doc Management', id: 20 },
  { name: 'Reviewing Physician', id: 21 },
  { name: 'Limited Admin', id: 22 },
  { name: 'Support Admin', id: 23 },
  { name: 'OMMU Doc Staff', id: 24 },
  { name: 'OMMU Call Staff', id: 25 }
];

export const patientApplicationPartStatus = {
  NotSubmitted: 1,
  Submitted: 2,
  CompletedOrApproved: 3,
  Rejected: 4,
  Bypassed: 5,
};

export const applicationTypeId = {
  Initial: 1,
  Renewal: 2,
  AddressChange: 3
};

export const AppType = {
  patient: 'patient',
  caregiver: 'caregiver'
};

export const proofStatus = {
  NotSubmitted: 1,
  Submitted: 2,
  Approved: 3,
  Rejected: 4
};

export const applicationApprovalStatus = {
  NotSubmitted: 1,
  Submitted: 2,
  Approved: 3,
  Rejected: 4
};

export const applicationPhotoSource = {
  Hsmv: '1',
  Manual: '2'
};

export const paymentStatus = {
  PendingOnline: 1,
  Processed: 2,
  Rejected: 3,
  Processing: 4
};

export const myPatientsOptions = {
  CertifiedPatients: 1,
  UncertifiedPatients: 2,
  ExpiringSoon: 3,
  AllPatients: 4,
  PeopleSearch: 5,
  AddNewPatient: 6
};

export const patientToStatusId = {
  Activate: 1,
  Deactivate: 2,
};

export const CardHolderTypeId = {
  Patient: 1,
  Caregiver: 2,
};

export const paymentStatusDesc = {
  1: 'Pending Online',
  2: 'Processed',
  3: 'Rejected',
  4: 'Processing'
};

export const applicationPartStatus = {
  applicationType: {
    1: 'Initial Application',
    2: 'Renewal Application',
    3: 'Change Application',
  },
  photoStatus: {
    1: 'Not Submitted',
    2: 'Submitted',
    3: 'Approved',
    4: 'Rejected'
  },
  proofStatus: {
    1: 'Not Submitted',
    2: 'Submitted',
    3: 'Approved',
    4: 'Rejected'
  },
  signatureStatus: {
    1: 'Not Signed',
    3: 'Signed'
  },
  paymentStatus: {
    1: 'Not Submitted',
    2: 'Processing',
    3: 'Processed',
    4: 'Rejected'
  },
  applicationApprovalStatus: {
    1: 'Not Submitted',
    2: 'Application Under Review',
    3: 'Approved',
    4: 'Rejected'
  },
  printedStatus: {
    1: 'Card Not Printed',
    3: 'Card Printed',
    5: 'Card Print Deferred'
  }
};

export const QualifyingDocumentationStatus = {
  Approved: 4,
  'Needs More Information': 6,
  'Not Yet Submitted': 1,
  Rejected: 7,
  Submitted: 2,
  'Under Review': 5,
  Withdrawn: 3,
};

export const QualifyingDocumentationType = {
  CRAF: 1
};

export const crceRelationshipOptions = [{ name: 'Select Relationship Type', id: null }, { id: 1, name: 'Spouse' }, { id: 2, name: 'Grandparent/Step-Grandparent' },
  { id: 3, name: 'Sibling/Step-Sibling' }, { id: 4, name: 'Parent/Step-Parent' },
  { id: 5, name: 'Grandchild/Step-Grandchild' }, { id: 6, name: 'Child/Step-Child' }];

export const substantiatingDocTypes = [
  { id: 1, name: 'Marriage Certificate' },
  { id: 2, name: 'Birth Certificate' },
  { id: 3, name: 'Adoption Decree' },
  { id: 4, name: 'Divorce/Custody Decree' },
  { id: 5, name: 'Other' }];

export const crceMessages = {
  1: 'Document saved successfully',
  2: 'Document submitted successfully',
  3: 'Document withdrawn successfully',
  4: 'Document approved successfully',
  5: 'Document opened for review',
  6: 'Needs more information justification saved successfully',
  7: 'Document rejected successfully',
};

export const crceActionType = {
  1: 'Save as Draft',
  2: 'Submit',
  3: 'Withdraw',
  4: 'Approve',
  5: 'Open For Review',
  6: 'Needs More Information',
  7: 'Reject'
};

export const substantiatingDocStatus = {
  Rejected: 'Rejected',
  Approved: 'Approved'
};

export const RfeActionType = {
  1: 'Save As Draft',
  2: 'Submit',
  3: 'Withdraw',
  4: 'Approve',
  5: 'Open For Review',
  6: 'Needs More Information',
  7: 'Reject'
};

export const CERTIFICATION_DOCS_TYPE = [
  { label: '2PC', value: 5 },
  { label: 'ARF', value: 2 },
  { label: 'CMP', value: 6 },
  { label: 'RFE', value: 3 },
  { label: 'SKC', value: 1 },
];

export const DOCUMENT_DASHBOARD_DOCS_TYPE = [
  { label: '2PC', value: 5 },
  { label: 'CMP', value: 6 },
  { label: 'CRAF', value: 4 },
  { label: 'RFE', value: 3 },
];

export const DOCUMENT_DASHBOARD_STATUS = [
  { label: 'Submitted', value: 2 },
  { label: 'Under Review', value: 5 }
];

export const PATIENT_CERTIFICATION_DOCS_TYPE = [
  { label: '2PC', value: 5 },
  { label: 'CMP', value: 6 },
  { label: 'RFE', value: 3 },
];

export const DOCUMENT_REVIEW_DASH_TYPE = [
  { label: '2PC', value: 5 },
  { label: 'CMP', value: 6 },
  { label: 'RFE', value: 3 },
  { label: 'CRAF', value: 4 }
];

export const TEXT_AREA_MAX_LENGTH = 30000;

export const QUALIFYING_MEDICAL_CONDITION = {
  1: 'Cancer',
  2: 'Epilepsy',
  3: 'Glaucoma',
  4: 'Positive status for human immunodeficiency virus',
  5: 'Acquired immune deficiency syndrome',
  6: 'Post-traumatic stress disorder',
  7: 'Amyotrophic lateral sclerosis',
  8: "Crohn's disease",
  9: "Parkinson's disease",
  10: 'Multiple sclerosis'
};

export const CertDocsCategoryId = {
  QualificationDocs: 1,
  EffectiveDocs: 2,
  LessHarmDocs: 3,
  SecondPhysicianDocs: 4,
  AppropriateRouteDocs: 5,
  InsufficientDosageDocs: 6,
  SubstantiatingRelationshipDocs: 7,
  CloseRelativeAcknowledgementForm: 8,
  MedicalMarijuanaConsentForm: 9,
  RfeNmiMedicalRecords: 10
};

export const WorkflowTransistionStateActions = {
  SaveAsDraft: 'Save As Draft',
  Submit: 'Submit',
  Unsubmit: 'Unsubmit',
  Resubmit: 'Resubmit',
  OpenForReview: 'Open for Review',
  NeedMoreInfo: 'Needs More Information',
  Approve: 'Approve',
  Withdraw: 'Withdraw',
  Update: 'Update',
  Reject: 'Reject'
};

export const ArfDocumentationToStateId = {
  Save: 1,
  Submit: 2,
};

export const CmpDocumentationToStateId = {
  Save: 1,
  Submit: 2,
  Approved: 4,
  OpenForReview: 5,
  NeedMoreInfo: 6
};

export const SpcDocumentationToStateId = {
  Save: 1,
  Submit: 2,
  Withdrawn: 3,
  Approve: 4,
  UnderReview: 5,
  NeedMoreInfo: 6,
  Rejected: 7
};

export const RfeDocumentationToStateId = {
  Save: 1,
  Submit: 2,
  Withdrawn: 3,
  Approve: 4,
  UnderReview: 5,
  NeedMoreInfo: 6,
  Rejected: 7
};

export const SkcDocumentationToStateId = {
  Save: 1,
  Submit: 2
};

export const CrceDocumentationToStateId = {
  Save: 1,
  Submit: 2,
  Withdrawn: 3,
  Approve: 4,
  UnderReview: 5,
  NeedMoreInfo: 6,
  Reject: 7
};

export const CERTIFICATION_DOCS_STATES = {
  'Not Yet Submitted': 1,
  Submitted: 2,
  Withdrawn: 3,
  Approved: 4,
  'Under Review': 5,
  'Needs More Information': 6,
  Rejected: 7
};

export const CERTIFICATION_DOCS_STATE = {
  5: [
    { label: 'Not Yet Submitted', value: 1 },
    { label: 'Submitted', value: 2 },
    { label: 'Withdrawn', value: 3 },
    { label: 'Approved', value: 4 },
    { label: 'Under Review', value: 5 },
    { label: 'Needs More Information', value: 6 },
    { label: 'Rejected', value: 7 }],
  3: [
    { label: 'Not Yet Submitted', value: 1 },
    { label: 'Submitted', value: 2 },
    { label: 'Withdrawn', value: 3 },
    { label: 'Approved', value: 4 },
    { label: 'Under Review', value: 5 },
    { label: 'Needs More Information', value: 6 },
    { label: 'Rejected', value: 7 }],
  6: [
    { label: 'Not Yet Submitted', value: 1 },
    { label: 'Submitted', value: 2 },
    { label: 'Withdrawn', value: 3 },
    { label: 'Approved', value: 4 },
    { label: 'Under Review', value: 5 },
    { label: 'Needs More Information', value: 6 }],
  2: [
    { label: 'Not Yet Submitted', value: 1 },
    { label: 'Submitted', value: 2 }],
  1: [
    { label: 'Not Yet Submitted', value: 1 },
    { label: 'Submitted', value: 2 }]
};

export const CERTIFICATION_DOCS_SORT_VALUE = {
  patientFirstName: 1,
  patientLastName: 2,
  patientNumber: 3,
  documentationType: 4,
  certDates: 5,
  certificationStartDate: 5,
  status: 6,
  dateLastSubmitted: 7,
  physician: 8,
};

export const QUALIFYING_DOCS_SORT_VALUE = {
  documentationType: 1,
  status: 2,
  caregiverName: 3,
  caregiverNumber: 4,
  dateLastSubmitted: 5,
  statusDate: 6,
};

export const CERTIFICATION_SORT_VALUE = {
  certificationStatus: 1,
  certificationStartDate: 2,
  certificationEndDate: 3,
  orderCount: 4,
  physicianName: 5,
};

export const DOCUMENT_DASHBOARD_SORT_VALUE = {
  cardholderId: 1,
  certificationStartDate: 2,
  documentationType: 3,
  medicalRecords: 4,
  documentationState: 5,
  dateLastSubmitted: 6,
  assignedTo: 7,
  physician: 8,
};

export const SORT_ORDER = {
  asc: 1,
  desc: 2
};

export const CertificationFormPages = {
  PageOne: 1,
  PageTwo: 2,
  PageThree: 3
};

export const CertificationYesNoValues = {
  Yes: 1,
  No: 2,
};

export const RestrictedYesNoValues = {
  No: 0,
  Yes: 1,
};

export const UserPermissionsIds = {
  PeopleSearch: 2,
  SearchCardHolderByNameDob: 3,
  SearchCardHolderByIdDob: 4,
  SearchTransporterByNameDob: 5,
  ViewPatientProfile: 6,
  ReadOrders: 7,
  ReadOrderRoutes: 8,
  ReadDispensations: 9,
  CreateDispensations: 10,
  AccessCorrectDispensations: 11,
  UpdateDispensations: 12,
  Deliveries: 13,
  MyDeliveries: 14,
  ManageDeliveries: 15,
  ReadDeliveries: 16,
  CreateDeliveries: 17,
  UpdateDeliveries: 18,
  AccessUsers: 19,
  AccessNewApplicant: 20,
  ManageUsers: 21,
  ReadUsers: 22,
  UpdateUsers: 23,
  CreateUsers: 24,
  DeleteUsers: 25,
  AccessReports: 26,
  ReadMmtcReports: 27,
  ChangePassword: 28,
  AccessTraining: 29,
  MyProfile: 31,
  AccessTransporters: 32,
  ReadTransporters: 33,
  CreateTransporters: 34,
  UpdateTransporters: 35,
  DeleteTransporters: 36,
  ReadCaregiver: 37,
  ReadPhysician: 38,
  ReadPatient: 39,
  EditQualifyingDoc: 40,
  ReadQualifyingDoc: 41,
  DismissTraining: 42,
  SelfSignature: 43,
  RequiresTraining: 44,
  DeferTraining: 45,
  ReadLEOReports: 46,
  ReadExecutiveReports: 47,
  ReadCertificationDocumentation: 48,
  EditCertificationDocumentation: 49,
  ReadApplicants: 50,
  CorrectDispensations: 51,
  LeavePhysician: 52,
  ManageYourInformation: 53,
  AccessPatientCard: 54,
  ReadMyApplications: 55,
  ReadProofResidenceDocs: 56,
  EditProofResidenceDocs: 57,
  PatientProfile: 58,
  AccessCaregiverCard: 54,
  CaregiverCard: 59,
  CaregiverProfile: 60,
  ManagePatientInformation: 61,
  UpdatePatientContactInfo: 62,
  UpdateCaregiverContactInfo: 63,
  UpdateRepresentedPatientProfile: 64,
  UpdateRepresentedPatientCard: 65,
  ReadPatientApplication: 66,
  UpdatePatientApplication: 67,
  UpdateCaregiverApplication: 68,
  CancelMyApplications: 69,
  ViewDriversLicenseOnProfile: 70,
  AccessQualifyingDoc: 71,
  AccessMyPhysicianProfile: 72,
  AccessMyPatients: 73,
  EditPhysicianEmailAddress: 74,
  ViewMyPatients: 75,
  PatientManagement: 76,
  AccessCertificationDocumentation: 77,
  CreatePatient: 78,
  SearchCardHolderByIdOnly: 79,
  SearchCardHolderBySsn: 80,
  AccessMyPatientsAll: 81,
  ViewAllPatients: 82,
  ReviewQualifyingDoc: 83,
  EditQualifyingDocUpload: 84,
  AccessQualifyingDocAll: 85,
  AccessCertificationDocAll: 86,
  ReviewCertificationDocumentation: 87,
  ReadCertDoc2pc: 88,
  ReadCertDocSkc: 89,
  ReadCertDocArf: 90,
  ReadCertDocCmp: 91,
  ReadCertDocRfe: 92,
  EditCertDocSkc: 93,
  EditCertDocArf: 94,
  EditCertDocCmp: 95,
  ReviewCertDoc2pc: 96,
  ReviewCertDocCmp: 97,
  ReviewCertDocRfe: 98,
  ActivateUnassignedPatients: 99,
  DeactivatePatient: 100,
  ViewPatientCertifications: 101,
  ManagePatientCertifications: 102,
  ManagePatientOrders: 103,
  AccessTools: 104,
  AccessApiTools: 105,
  AccessApiToolsMqa: 106,
  SystemManagement: 107,
  ManageRestrictedPhysicians: 108,
  AccessMMTCs: 109,
  ReadMMTCs: 110,
  CreateMMTCs: 111,
  UpdateMMTCs: 112,
  DeleteMMTCs: 113,
  AccessLEOs: 114,
  ReadLEOs: 115,
  CreateLEOs: 116,
  UpdateLEOs: 117,
  DeleteLEOs: 118,
  ManageUnclosedOrUnsignedCertifications: 119,
  AdminReviewApplicant: 120,
  AdminReadApplicant: 121,
  AccessDeceasedUserManagement: 122,
  ViewDeceasedUserManagement: 123,
  EditDeceasedUserManagement: 124,
  AccessRestrictedPhysicians: 125,
  ViewTransporterDetails: 126,
  AdjudicateTransporters: 127,
  AccessDuplicatePatientsOrCaregivers: 128,
  ManageDuplicatePatientsOrCaregivers: 129,
  ManagePatientCaregiver: 130,
  AccessMQAToggle: 131,
  ManageMQAToggle: 132,
  AdminResetPassword: 139,
  AccessApiToolsHsmvDemo: 140,
  AccessContentManagement: 141,
  ReadContentManagement: 142,
  CreateContentManagement: 143,
  UpdateContentManagement: 144,
  DeleteContentManagement: 145,
  AccessApiToolsHsmvPhoto: 146,
  AccessUserRoles: 147,
  ReadUserRoles: 148,
  CreateUserRoles: 149,
  UpdateUserRoles: 150,
  DeleteUserRole: 151,
  ManageDemographicsHsmvHook: 152,
  AccessApplications: 153,
  AdminReadApplications: 154,
  AdminReviewApplications: 155,
  AdminSupplyApplications: 156,
  AdminCancelApplications: 157,
  CreatePatientApplication: 158,
  CreateCaregiverApplication: 159,
  AccessAdminSystemHistory: 160,
  AdminApproveApplications: 161,
  AdminRejectApplications: 162,
  AdminChangeCardStatus: 163,
  ViewRestrictedPhysicians: 164,
  ReportChapter893Violations: 165,
  Access893Violations: 166,
  Read893Violations: 167,
  AdjudicateChapter893Violation: 168,
  AccessPatientCertificationDocumentationStatus: 169,
  HideDeceasedPatient: 170,
  RemoveSuspension: 172,
  RemoveAPISuspension: 173,
  DeferCardPrint: 174,
  ManageSsoStatus: 175,
  FlagInsufficentMailingAddress: 178,
  AdminReadPrimaryKeys: 179,
  AccessDashboard: 181,
  AccessSystemInformation: 182,
  AccessMfa: 183,
  ReadMfa: 184,
  ManageMfaStatus: 185,
  VerifyMfa: 186,
  ReadCertificationDocStateHistory: 187,
  ReadQualifyingDocStateHistory: 188,
  AccessDocumentReviewDashboard: 189,
  AccessDocumentAssignmentDashboard: 190,
  DocumentAssignment: 191,
  AccessDocumentAssignment: 192,
  AccessCertDocAssignment: 193,
};

export const certDocsPermissionType = {
  5: UserPermissionsIds.ReadCertDoc2pc,
  1: UserPermissionsIds.ReadCertDocSkc,
  2: UserPermissionsIds.ReadCertDocArf,
  6: UserPermissionsIds.ReadCertDocCmp,
  3: UserPermissionsIds.ReadCertDocRfe,
};

export const patientManagementTabs = {
  PatientInformation: 0,
  CaregiverAssignment: 1,
  Certifications: 2,
  Orders: 3,
  CertDocs: 4
};

export const orderTabs = {
  AdminOrderSummary: 0,
  LowThc: 0,
  MedicalMarijuana: 1,
  Smoking: 2,
  OrderSummary: 3,
};

export const OrderCancelState = {
  Cancel: 1,
  Reinstate: 2
};

export const AdverseEventSortValues = {
  shortAdverseEvent: 1,
  startDate: 2,
  severity: 3,
  actionTaken: 4,
  finalOutCome: 5,
  stopDateOrContinuing: 6,
  relationshipToMedicalMarijuana: 7,
  expected: 8,
  serious: 9
};

export const ControlledSubstancesSortValues = {
  substance: 1,
  startingDose: 2,
  currentDose: 3,
  startDate: 4,
  dateDiscontinued: 5
};

export const ProfileType = {
  Patient: 1,
  Caregiver: 2
};

export const StatusChange = {
  'Not Overridden': 1,
  Overridden: 2,
  'Override Removed': 3
};

export const RestrictionSource = {
  'MQA Not Overridden': 1,
  'MQA Overridden': 2,
  'OMMU Future Restriction': 3,
  'OMMU Restricted': 4
};

export const UserDeceasedSource = {
  Hsmv: 1,
  Manual: 2
};

export const DeceasedAction = {
  NoOverride: 1,
  Override: 2,
  OverrideRemoved: 3,
  DeceasedManually: 4,
  ReverseDeceasedManually: 5
};

export const DeceasedUserSortValues = {
  firstName: 1,
  lastName: 2,
  profileType: 3,
  actionDate: 4,
  statusChange: 5,
  overrideExpirationDate: 6,
  dob: 7,
};

export const RestrictedPhysiciansSortValues = {
  name: 1,
  licenseNumber: 2,
  restrictionSource: 3,
};

export const DuplicateUserSortValues = {
  firstName: 1,
  lastName: 2,
  idNumber: 3,
  dateCreated: 4,
  createdBy: 5,
  lastLogin: 6
};

export const CargiverAssigmentScreenToShow = {
  NewPatientScreen: 1,
  AssignedCaregiversGrid: 2,
  AddNewCaregiverForm: 3,
  EditCaregiverForm: 4
};

export const ContentUserTypes = [
  { id: 0, name: 'All', sort: 1 },
  { id: 1, name: 'Admins', sort: 2 },
  { id: 2, name: 'Physicians', sort: 6 },
  { id: 3, name: 'Cardholders', sort: 3 },
  { id: 4, name: 'LEO', sort: 4 },
  { id: 5, name: 'MMTC', sort: 5 },
];

export const ContentDashboardSortValues = {
  UserType: 1,
  Title: 2,
  StartDate: 3,
  EndDate: 4,
  Status: 5
};

export const DeliveryMethod = {
  ToBeAssigned: 0,
  PatientPickedUp: 1,
  NoDelivery: 2,
  CaregiverPickedUp: 3,
  DelivererAssigned: 4
};

export const UserTypeDropdownChange = {
  Admin: 1,
  Physician: 2,
  Cardholders: 3,
  LEO: 4,
  MMTC: 5
};

export const UserRolesSortValues = {
  userType: 1,
  roleName: 2,
};

export const HistoryOptions = {
  PatientHistory: 0,
  UserHistory: 1,
  SearchHistory: 2,
  NegativeSearchHistory: 3,
  OrderHistory: 4,
  OrderRouteHistory: 5,
  PhysicianSearchHistory: 6,
  MailingAddressHistory: 7
};

export const WeightType = {
  Lbs: 1,
  Kg: 2
};

export const PhotoStatus = {
  Uploaded: 1,
  Approved: 2,
  Rejected: 3,
  Unapproved: 4,
  Removed: 5,
  Renewed: 6
};

export const PORStatus = {
  Uploaded: 1,
  Approved: 2,
  Rejected: 3,
  Unapproved: 4,
  Removed: 5,
  Renewed: 6
};

export const applicationPartStatusEnum = {
  NotSubmitted: 1,
  Submitted: 2,
  CompletedOrApproved: 3,
  Rejected: 4,
  Bypassed: 5
};

export const revocationType = {
  Chapter893: 1,
  Other: 2
};

export const certificationQuestionSet = {
  Legacy: 1,
  NewCertification: 2,
  Recertification: 3
};

export const CertificationQuestionType = {
  PatientConsentLetter: 1,
  Pregnant: 2,
  ConductedExamPerson: 3,
  ReviewedHistory: 4,
  HarmOutweighsNone: 5,
  Telehealth: 6,
  NoExistingPhysicianCert: 7
};

export const medicalConditionIds = {
  Skc: 11,
  ChronicNonmalignant: 13
};

export const cardHolderRoles = {
  Patient: 1,
  Caregiver: 2,
  Combo: 3
};

export const mfaTokenType = {
  'Authenticator App': 1,
  'Email Notification': 2,
};

export const drugOffenseSuspensionStatus = {
  Submitted: 1,
  'Under Review': 2,
  'Processed: Suspended': 3,
  'Processed: Not Suspended': 4
};

export const drugOffenseSuspensionSort = {
  cardholderName: 1,
  cardholderIdentifier: 2,
  dateLastSubmitted: 3,
  status: 4,
  reportingLeo: 5,
  role: 6
};

export const suspensionTypeId = {
  Manual: 1,
  Api: 2,
  Chapter893: 3,
  Nic: 4
};

export const applicationDrawerItemsPosition = {
  gettingStarted: 0,
  demographics: 2,
  photo: 4,
  proofOfResidence: 6,
  mailingAddress: 8,
  signature: 10,
  payment: 12,
  admin: 14
};

export const hsmvSectionsPosition = {
  demographics: applicationDrawerItemsPosition.demographics,
  photo: applicationDrawerItemsPosition.photo,
  proofOfResidence: applicationDrawerItemsPosition.proofOfResidence,
};

export const PhysicianType = {
  Physician: 1,
  MedicalDirector: 2,
};

export const dispenserUiStateIds = {
  On: 1,
  Off: 2,
  NoKeyOnly: 3,
};

export const patientProfileTab = {
  PatientInformation: 0,
  ManageCaregiver: 1,
  Certifications: 2,
  Orders: 3,
  CertDocs: 4,
  QualDocs: 5
};

export const AddressVerificationStatus = {
  Exact: 'Exact',
  Confirm: 'Confirm',
  NotFound: 'NotFound',
  Incomplete: 'Incomplete'
};
